"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _PreviewWrapper = _interopRequireDefault(require("../PreviewWrapper"));
var _Export = _interopRequireDefault(require("../Export"));
var _shouldUpdate = _interopRequireDefault(require("recompose/shouldUpdate"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _getWysiwygText = _interopRequireDefault(require("cccisd-survey-common/dist/helpers/getWysiwygText.js"));
var _download = _interopRequireDefault(require("cccisd-icons/download"));
var _general = _interopRequireDefault(require("./general.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Element = /*#__PURE__*/function (_React$Component) {
  _inherits(Element, _React$Component);
  var _super = _createSuper(Element);
  function Element() {
    var _this;
    _classCallCheck(this, Element);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_changeCurrentElement", function () {
      // Don't change current element if there is no builder settings
      if (_this.props.elementType.builder) {
        _this.props.changeCurrentElement(_this.props.element.id);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_deleteElement", function (event) {
      var _this$props = _this.props,
        element = _this$props.element,
        moveElementToTrash = _this$props.moveElementToTrash;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (element.children && element.children.length > 0) {
        (0, _cccisdConfirm["default"])({
          message: 'Are you sure?',
          description: 'You are going to delete many components'
        }).then(function () {
          moveElementToTrash(element.id);
        });
      } else {
        moveElementToTrash(element.id);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_duplicateElement", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      _this.props.duplicateElement(_this.props.element.id);
    });
    _defineProperty(_assertThisInitialized(_this), "_undoChanges", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      _this.props.undoChanges(_this.props.element.id);
    });
    _defineProperty(_assertThisInitialized(_this), "_redoChanges", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      _this.props.redoChanges(_this.props.element.id);
    });
    _defineProperty(_assertThisInitialized(_this), "_getDuplicateButton", function () {
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: _style["default"].button,
        title: "Duplicate element",
        onClick: _this._duplicateElement,
        key: "duplicate",
        id: "component_duplicate_button_".concat(_this.props.element.id)
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-duplicate"
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_getDeleteButton", function () {
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: _style["default"].button,
        title: "Delete element",
        onClick: _this._deleteElement,
        key: "delete"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-trash"
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_getUndoButton", function () {
      if (!_this.props.isDirty) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: _style["default"].button,
        title: "Undo changes",
        onClick: _this._undoChanges,
        key: "undo"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-share-alt",
        style: {
          transform: 'scaleX(-1)'
        }
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_getRedoButton", function () {
      if (!_this.props.isRedo) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: _style["default"].button,
        title: "Redo changes",
        onClick: _this._redoChanges,
        key: "redo"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-share-alt"
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_getPreviewButton", function () {
      var trigger = /*#__PURE__*/_react["default"].createElement("a", {
        className: _style["default"].button,
        title: "Preview element",
        id: "component_preview_button_".concat(_this.props.element.id)
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-eye-open"
      }));
      return /*#__PURE__*/_react["default"].createElement(_PreviewWrapper["default"], {
        key: "preview",
        trigger: trigger,
        parentId: _this.props.element.id
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getExportButton", function () {
      var trigger = /*#__PURE__*/_react["default"].createElement("a", {
        className: _style["default"].button,
        title: "Export element",
        id: "component_export_button_".concat(_this.props.element.id)
      }, /*#__PURE__*/_react["default"].createElement(_download["default"], null));
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: trigger,
        title: "Export",
        key: "export"
      }, /*#__PURE__*/_react["default"].createElement(_Export["default"], {
        topId: _this.props.element.id
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_toggleElementPreview", function () {
      _this.props.toggleElementPreview(_this.props.element.id);
    });
    _defineProperty(_assertThisInitialized(_this), "_getButtons", function (list) {
      var defaultButtons = {
        undo: _this._getUndoButton(),
        redo: _this._getRedoButton(),
        preview: _this._getPreviewButton(),
        duplicate: _this._getDuplicateButton(),
        "export": _this._getExportButton(),
        "delete": _this._getDeleteButton()
      };
      if ((0, _isArray2["default"])(list) && (0, _isEmpty2["default"])(list)) {
        return null;
      }
      var buttons = list ? (0, _pick2["default"])(defaultButtons, list) : defaultButtons;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttonWrapper
      }, (0, _map2["default"])(buttons, function (button) {
        return button;
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_getElement", function () {
      var _this$props2 = _this.props,
        element = _this$props2.element,
        elementType = _this$props2.elementType,
        initialValues = _this$props2.initialValues,
        isCurrent = _this$props2.isCurrent,
        viewMode = _this$props2.viewMode;
      var formName = 'preview' + element.id;
      var Player = _this.props.player;
      var buttons = _this._getButtons(elementType.previewButtons);
      var showPreview;
      var className;
      var result;
      if (element.showPreview === undefined) {
        showPreview = viewMode === 'preview' || isCurrent ? true : false;
      } else {
        showPreview = element.showPreview;
      }
      if (isCurrent) {
        className += ' ' + _style["default"].current;
      }
      var adjustedSettings = _objectSpread(_objectSpread({}, elementType.builderInitialValues), element.settings);
      if (elementType.isStaticPlayer) {
        result = /*#__PURE__*/_react["default"].createElement("div", null, buttons, /*#__PURE__*/_react["default"].createElement(Player, {
          form: formName,
          settings: adjustedSettings,
          initialValues: initialValues,
          isPreview: true
        }));
      } else if (showPreview) {
        // changed key will tell us to unmount/mount the preview player
        // we can prevent it for UI reason by not changing the key every time
        var key = elementType.getSettingsHashForPreview ? elementType.getSettingsHashForPreview(adjustedSettings) : element.settingsHash;
        className += ' ' + _style["default"].element;
        result = /*#__PURE__*/_react["default"].createElement("div", null, buttons, /*#__PURE__*/_react["default"].createElement(_general["default"], {
          settings: adjustedSettings
        }), /*#__PURE__*/_react["default"].createElement(Player, {
          key: key,
          form: formName,
          settings: adjustedSettings,
          initialValues: initialValues,
          isPreview: true,
          showRequiredState: true,
          showQuestionNumbers: _this.props.showQuestionNumbers,
          startQuestionNumber: _this.props.startQuestionNumber,
          dynamicUserLists: _this.props.dynamicUserLists,
          dynamicUserListsValues: _this.props.dynamicUserListsValues,
          defaultValues: _this.props.defaultValues
        }));
      } else {
        className += ' ' + _style["default"].briefElement;
        result = /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].textOverflow
        }, buttons, elementType.icon && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].icon
        }, elementType.icon), (0, _getWysiwygText["default"])(element.settings[elementType.labelField]));
      }
      var wrapperClassNames = (0, _classnames["default"])([_style["default"].elementWrapper]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: wrapperClassNames,
        id: "component_wrapper_".concat(element.id)
      }, false && !elementType.isStaticPlayer && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].toggle + ' text-primary',
        onClick: _this._toggleElementPreview
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-triangle-".concat(showPreview ? 'bottom' : 'right')
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].elementCommon + ' ' + className,
        onClick: _this._changeCurrentElement
      }, _this.props.isDirty && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].mark + ' ' + _style["default"].dirty,
        title: "Changed"
      }), _this.props.isNew && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].mark + ' ' + _style["default"]["new"],
        title: "New"
      }), result));
    });
    return _this;
  }
  _createClass(Element, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, this._getElement());
    }
  }]);
  return Element;
}(_react["default"].Component);
_defineProperty(Element, "propTypes", {
  element: _propTypes["default"].object,
  elementType: _propTypes["default"].object,
  initialValues: _propTypes["default"].object,
  isCurrent: _propTypes["default"].bool,
  isDirty: _propTypes["default"].bool,
  isRedo: _propTypes["default"].bool,
  isNew: _propTypes["default"].bool,
  viewMode: _propTypes["default"].string,
  player: _propTypes["default"].func,
  changeCurrentElement: _propTypes["default"].func,
  moveElementToTrash: _propTypes["default"].func,
  duplicateElement: _propTypes["default"].func,
  undoChanges: _propTypes["default"].func,
  redoChanges: _propTypes["default"].func,
  toggleElementPreview: _propTypes["default"].func,
  showRequiredState: _propTypes["default"].bool,
  showQuestionNumbers: _propTypes["default"].bool,
  startQuestionNumber: _propTypes["default"].number,
  dynamicUserLists: _propTypes["default"].array,
  dynamicUserListsValues: _propTypes["default"].object,
  defaultValues: _propTypes["default"].array
});
var _default = (0, _shouldUpdate["default"])(function (props, nextProps) {
  // Rerender only in some conditions
  return props.isCurrent || nextProps.isCurrent || props.isDirty !== nextProps.isDirty || props.isNew !== nextProps.isNew || props.viewMode !== nextProps.viewMode || props.showQuestionNumbers !== nextProps.showQuestionNumbers || props.startQuestionNumber !== nextProps.startQuestionNumber || props.element.showPreview !== nextProps.element.showPreview || props.element.children !== nextProps.element.children;
})(Element);
exports["default"] = _default;